import { FilterCategory, SearchFilterBase, SearchFilterType } from '../types';

export default function locationsWorldwideFilterConfig(): SearchFilterBase {
  return {
    id: '# of Locations World Wide',
    name: '# of Locations World Wide',
    icon: 'near-me',
    index: 20,
    type: SearchFilterType.ROOT,
    category: [FilterCategory.COMPANY_DATA],
    pinned: true,
    utils: {
      tags: {
        config: {
          showAsCard: true,
          tagsCardTitle: 'Global Location Count',
        },
      },
    },
    items: [
      {
        type: SearchFilterType.NUMBER_RANGE,
        icon: undefined,
        index: 0,
        layer: 4,
        field: 'number_of_retail_locations',
        key: 'number_of_retail_locations',
        name: 'Location Range',
        metadata: { color: 'primary' },
      },
    ],
  };
}
